import { render, staticRenderFns } from "./HospitalParceiro.vue?vue&type=template&id=59bcd021&"
import script from "./HospitalParceiro.vue?vue&type=script&lang=js&"
export * from "./HospitalParceiro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports